import React from 'react'
import styled from 'styled-components'
import Cleave from 'cleave.js'
import formatNumber from './helpers/formatNumber'

const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  font-weight: ${props => props.bold ? 'bold' : 'normal'};
  padding: 4px 0px;
`
const Title = styled.div`
  text-align: left;
  padding: 8px;
`
const Value = styled.div`
  text-align: right;
  padding: 8px;
`
const InputContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  justify-self: end;
  align-self: center;
`
const Input = styled.input`
  text-align: right;
  padding: 6px;
  border-radius: 3px;
  width: 48%;
  justify-self: end;
  outline: none;
  padding: 4px 6px !important;
  border: 1px solid #ccc !important;
`

export default class BalanceCell extends React.Component {
  constructor() {
    super()
    this.state = {
      cleave: null
    }
  }
  componentDidUpdate(prevProps) {
    if (!prevProps.isEditable && this.props.isEditable && this.input) {
      this.setupCleave()
    } else if (prevProps.isEditable && !this.props.isEditable) {
      this.destroyCleave()
    }
  }
  setupCleave = () => {
    const { valueKey, onValueChange } = this.props
    this.setState({
      cleave: new Cleave(`#${valueKey}`, {
        numeral: true,
        numeralDecimalScale: 2,
        stripLeadingZeroes: true,
        numeralPositiveOnly: true,
        onValueChanged: e => onValueChange(e, valueKey)
      })
    })
  }
  destroyCleave = () => {
    const { cleave } = this.state
    if (cleave) {
      cleave.destroy()
      this.setState({ cleave: null })
    }
  }
  renderValue = () => {
    const { value, isEditable, valueKey } = this.props
    if (isEditable && valueKey !== null) {
      return (
        <InputContainer>
          <Input
            ref={node => this.input = node}
            defaultValue={value}
            id={valueKey}
          />
        </InputContainer>
      )
    } else {
      return (
        <Value>{typeof value === 'number' ? formatNumber(value) : value}</Value>
      )
    }
  }
  render() {
    const { title, bold, className } = this.props
    return (
      <Container bold={bold} className={className}>
        <Title>{title}</Title>
        {this.renderValue()}
      </Container>
    )
  }
}